/// <amd-module name="Agile/Common/Utils/NullCheck" />
export function isNullOrUndefined(val) {
    return val === null || val === undefined;
}
